import { useCallback, useEffect, useMemo, useState,  } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu, ConfigProvider } from 'antd';
import { useAuth } from 'hooks/AuthContext';
import { useTableContext } from 'hooks/MenuTableAuthContext';

const { Sider } = Layout;

export const BaseSider = ({common, setCommon}) => {
  const location = useLocation();
  const [ userMenuArr, setUserMenuArr ] = useState([]);
  const { user, userMenu } = useAuth();
  const { openMenuInfo, fnOpenMenuInfo,} = useTableContext();

  const menuCustom = useMemo((data) => {
    let menuSet = new Set();
    userMenu.sort((obj1, obj2) => obj1.IDX - obj2.IDX)
    for(let i = 0; i <userMenu?.length; i++){
      if(userMenu[i].STATUS === 1 && (user?.level_no===userMenu[i].LEVEL_NO)) {
        menuSet.add(userMenu[i].DEPTH1_MENU_NAME);
      }
    }
    
    let arrdata = [];
    
    menuSet?.forEach((element,index) => {
      const subChildFilter = userMenu.filter((it) => it.DEPTH1_MENU_NAME === element &&  it.STATUS === 1);
      let menuObj = {};
      let subChild = [];
      let mainUrl = [];
      let mainIdx = [];
      let mainCode = [];
      //2depth
      subChildFilter?.map(i=>{
          const menuKey = i.MENU_URL?.split('/');
          mainUrl[index]='';
          mainIdx[index] =i.IDX;
          mainCode[index] =i.DEPTH2_MENU_CD;
          for(let k=0;k<menuKey?.length;k++){
            if(menuKey[k]) { 
              mainUrl[index] += ('/'+menuKey[k]) 
            };
          }
          subChild.push({
          label : (<Link to={i.MENU_URL}>{i.DEPTH2_MENU_NAME}</Link>),
          key: i.MENU_URL,
          url: i.MENU_URL,
          menu_idx: i.IDX,
          menu_code: i.DEPTH2_MENU_CD,
          name: i.DEPTH2_MENU_NAME,
        })
      })
      //1depth
      if(subChild?.length>1){
        menuObj = {
          label : element,
          name : element,
          // key: mainIdx[index]+element,
          url: mainUrl[index],
          children: [...subChild]  //children 있는경우
        }
      }else{
        menuObj = {
          label : (<Link to={mainUrl[index]}>{element}</Link>),
          menu_idx: mainIdx[index],
          menu_code: mainCode[index],
          name : element,
          key: mainUrl[index],
          url: mainUrl[index],
        }
      }
      arrdata.push(menuObj)
    });

    //하단에 새창열기 추가
    const openWindowArr ={
      label :<Link to='https://www.kinkos.co.kr/qmir' target="_blank">킨코스몰 바로가기</Link>,
      name : '킨코스몰 바로가기',
      key: 999,
      url: 'https://www.kinkos.co.kr/qmir'
    }
    arrdata.push(openWindowArr);
    setUserMenuArr(arrdata);
  },[user])
  
  const fnOnclick = (openKeys) => {
    if(openKeys?.key===location.pathname.trim()) {
      window.location.reload();
    }
  }
  
  const fnSelectMenu = (openKeys) => {
    const openMenuIDX = openKeys.item.props.menu_idx;
    const openMenuCd = openKeys.item.props.menu_code;
    const openMenuUrl = openKeys.key;
    if(openMenuCd){
      fnOpenMenuInfo({...openMenuInfo, id:openMenuIDX, code:openMenuCd, url:openMenuUrl});
      // setItem('openMenuCode',openMenuCd);
    }
    // const menuFilter = exportSample.filter((it)=>it.DEPTH2_MENU_CD === openMenuCd);
    
    // menuFilter.map((it)=>{
    //   const item = {
    //     title: it.LOGICAL_COLUMN_NAME,
    //     dataIndex: it.PHYSICAL_COLUMN_NAME,
    //     align: 'center',
    //   }
    //   tableColunm.push(item);
    // });

    // fnOpenMenuInfo({id:changedMenu.IDX, code:changedMenu.DEPTH2_MENU_CD, url:location})
  }

  const selectedKeys = useMemo(() => {
    const pathname = location.pathname.trim();
    const findList = userMenu.filter(item=> item.MENU_URL===pathname);
    
    
    if(findList[0]?.DEPTH2_MENU_NAME) {
      fnOpenMenuInfo({...openMenuInfo, depth:[findList[0].DEPTH1_MENU_NAME, findList[0].DEPTH2_MENU_NAME ]})
      
    } else {
      if(findList[0]){
        fnOpenMenuInfo({...openMenuInfo, depth:[findList[0].DEPTH1_MENU_NAME]})
      }
    }
    // 업무서식 - 좌측 메뉴 선택을 위해 key 일치 시키는 작업
    // if (pathname === URL_TASK_FORM+URL_TASK_FORM_MAIN) {
    //   const tab = searchParams.get('tab');
    //   if (tab === 'handbook') {
    //     pathname = URL_TASK_FORM+URL_TASK_FORM_HANDBOOK;
    //   } else if (tab === 'draft') {
    //     pathname = URL_TASK_FORM+URL_TASK_FORM_DRAFT;
    //   } else if (tab === 'brief') {
    //     pathname = URL_TASK_FORM+URL_TASK_FORM_BRIEF;
    //   }
    // }
    const pathnames = pathname.split('/');
    let arrPathnames = [];
    for (let i = 1; i < pathnames?.length; i++) {
      let path = '';
      for (let j = 1; j <= i; j++) {
        path = path.concat(`/${pathnames[j]}`);
      }
      arrPathnames.push(path);
    }

    if(!user){
      navigator('/login');
    }
    return arrPathnames;
  }, [,location.pathname]);


  const [openKeys, setOpenkeys] = useState([...selectedKeys]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemPaddingInline:'4',
          },
        },
      }}
    >
      <div style={{background:'#fff'}}>
        <Sider className="layout-sider" breakpoint={"lg"}>
            <Menu 
                mode="inline" 
                selectedKeys={selectedKeys} 
                openKeys={openKeys}
                onOpenChange={(openKeys) => setOpenkeys([`${openKeys[openKeys.length-1]}`]) }
                onSelect={fnSelectMenu}
                onClick={fnOnclick}
                items={userMenuArr} 
              />
        </Sider>
      </div>
    </ConfigProvider>
  );
};


